import TeamOverviewNavigation from './TeamOverviewNavigation';

export default TeamOverviewNavigation;
